import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DocumentService } from '../../../documents/services/document.service';
import { DocumentModalService } from '../../../documents/services/document-modal.service';
import { Router } from '@angular/router';
import { DocumentEntityType } from '../../../message-models/document-entity-type.enum';
import { ITrainingRecordDocumentSummary } from '../../../message-models/training-record-document-summary.interface';
import { TrainingRecordDocumentService } from '../../services/training-record-document.service';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { OurUserService } from '../../../users/services/user.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { EcaConfirmDeleteModalOptions } from "../../../shared/models/confirm-delete-modal-options.class";
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';

@Component({
  selector: 'app-training-record-documents-page',
  templateUrl: './training-record-documents-page.component.html',
  styleUrls: ['./training-record-documents-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class TrainingRecordDocumentsPageComponent implements OnInit, OnDestroy {
  trainingRecordDocuments: ITrainingRecordDocumentSummary[];
  loading: boolean;
  private loggedInUser: IUserInfo;
  public companyId: string = consts.emptyGuid;
  loggedInUserSubscription: Subscription;

  constructor(private trainingRecordDocumentService: TrainingRecordDocumentService,
    private documentService: DocumentService,
    private documentModalService: DocumentModalService,
    private router: Router,
    private confirmProcessService: EcaConfirmProcessService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private alertsService: AlertsService,
    private userService: OurUserService,
  ) {
  }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser.companyId;
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.loggedInUser = user;
        this.companyId = this.loggedInUser?.companyId;
        if (this.companyId !== consts.emptyGuid) {
          this.trainingRecordDocumentService.getAllTrainingRecordDocumentSummaries(this.companyId).subscribe(trainingRecordDocuments => {
            this.trainingRecordDocuments = trainingRecordDocuments;
            this.populateBreadcrumbs();
          });
        }
      })
    })
  }

  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
  }

  downloadTrainingRecordDocument(trainingRecordDocuments: ITrainingRecordDocumentSummary) {
    this.documentService.downloadOrOpenDocument(trainingRecordDocuments, true);
  }

  openTrainingRecordDocument(trainingRecordDocuments: ITrainingRecordDocumentSummary) {
    this.documentService.downloadOrOpenDocument(trainingRecordDocuments);
  }

  deleteTrainingRecordDocumentClick(trainingRecordDocument: ITrainingRecordDocumentSummary) {
    this.confirmProcessService.openConfirmProcessModal('Are you sure you want to delete this document?',
      'Delete ' + trainingRecordDocument.originalFilename, new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.deleteTrainingRecordDocument(trainingRecordDocument);
          }
        }
      });
  }

  deleteTrainingRecordDocument(trainingRecordDocument: ITrainingRecordDocumentSummary) {
    this.trainingRecordDocumentService.deleteTrainingRecordDocument(trainingRecordDocument.documentId, this.companyId).subscribe(
      result => {
        if (result) {
          const documentIndex = this.trainingRecordDocuments.findIndex(c => c.documentId !== trainingRecordDocument.documentId);
          this.trainingRecordDocuments.splice(documentIndex, 1);
          this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
        }
      }, error => {
      });
  }

  editTrainingRecordDocument(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.documentModalService.openDocumentUploaderModal(trainingRecordDocumentSummary, DocumentEntityType.trainingRecord, 'Edit Training Record Document').subscribe(documentModalRef => {
      documentModalRef.content.documentUploadSave.subscribe((documentUploadRequest: FormData) => {
        documentModalRef.dynamicDialogRef.close();
        documentUploadRequest.append('TrainingRecordId', trainingRecordDocumentSummary.trainingRecordId);
        documentUploadRequest.append('CompanyId', this.companyId);
        this.loading = true;
        this.trainingRecordDocumentService
          .createOrUpdateTrainingRecordDocument(documentUploadRequest).subscribe(updatedTrainingRecordDocumentsSummary => {
            this.loading = false;
            const documentIndex = this.trainingRecordDocuments.findIndex(d => d.documentId === trainingRecordDocumentSummary.documentId);
            this.trainingRecordDocuments[documentIndex] = updatedTrainingRecordDocumentsSummary;
            this.alertsService.getAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
          },
            uploadError => {

            });
      });
    });
  }

  viewTrainingRecordDocument(trainingRecordDocumentSummary: ITrainingRecordDocumentSummary) {
    this.router.navigate(['training-record-document', trainingRecordDocumentSummary.documentId]);
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({ label: 'Operatives', iconName: 'users', routeLink: '/operatives' } as IBreadcrumb);
    operativeBreadCrumbs.push({ label: 'Our Training Record Documents', iconName: 'books' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }
}
